export default "__VITE_ASSET__BZBADezi__"